export const lazyRendering = {
    /**
    * 137px is smallest prepack with two legs on EventPage for Desktop
    *
    */
    childMinHeight: 130,
    /**
     * The rootMargin here is set to be the average between smallest prePacks and longest one, 137px smallest prepack with two legs, 137px + 8 * 24px (+ 8 legs) = 329px; Its value can
     * be adjusted according to performance;
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API - documentation of observerOptions;
     */
    observerOptions: {
        rootMargin: "200px 0px"
    },
    /**
     * The number of prePacks per lazy render container, value can be adjusted according to performance;
     */
    lazyRenderChunkSize: 3
};
const tabsAnimation = {
    duration: 0.3,
    ease: "power1.in",
    step: 200
};
export const config = {
    /*
     Fibonacci numbers will be used as multiplier for timeouts between tries
     First failed try skipped =>
     Second retry timeout won't be used =>
        Retry process will take max =>
            0 + 0 + 200 + 400 + 600 + ... + 6800 = 17s 200ms
     */
    sseRetryInterval: 200,
    lazyRendering,
    tabsAnimation,
};
//# sourceMappingURL=config.js.map